import { createRoot } from 'react-dom/client';
import './index.css';

import App from './App.tsx';
import { iframeAuthService } from './api/iframeAuth';

// Show loading indicator during iframe auth initialization
const showLoading = () => {
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh;">
        <div style="text-align: center;">
          <div style="display: inline-block; width: 48px; height: 48px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          <p style="margin-top: 16px; color: #666;">Loading...</p>
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
  }
};

// Initialize and render app
async function initializeApp() {
  // Show loading during auth initialization
  showLoading();

  // Initialize iframe authentication if running in iframe context
  iframeAuthService.initializeIframeAuth();
  
  // Wait for iframe auth to complete
  await iframeAuthService.waitForInitialization();

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_MSW === 'on'
  ) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { worker } = require('./mocks/browser');
    await worker.start();
  }

  // Render the app after initialization
  const root = createRoot(document.getElementById('root'));
  root.render(<App />);
}

// Start the app
initializeApp().catch(console.error);
